export { FaqsItem } from './FaqsItem';
export type { FaqsItemProps } from './FaqsItem.types';
